import React, { useEffect } from 'react';
import Input from '../../elements/Input';
import Dropdown from '../../elements/Dropdown';
import Checkbox from '../../elements/Checkbox';
import Icon from '../../icons/Icon';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { buildMessage } from '../../../helpers/messageHelper';
import RadioGroup from '../../elements/RadioGroup';

const MatchForm = props => {
    const { state } = props;
    const navigate = useNavigate();
    const { register, handleSubmit, control, getValues, setValue } = useForm({
        shouldUseNativeValidation: true,
        mode: 'onBlur',
    });

    const onSubmit = async data => {
        let message = buildMessage(state.adviceArea, data);
        navigate('/message', {
            state: { adviceArea: state.adviceArea, formData: data, message: message, utm:state.utm },
        });
    };

    const handleCheckboxClick = event => {
        state.adviceArea = event.target.checked ? 635 : 393;
    };

    const handleClick = event => {
        event.target.classList.add('touched-input');
    };

    const maxWidthInputs = '280px';

    const handleBlur = e => {
        props.onInputBlur(getValues());
    };

    const getButtonLabel = () => {
        let label = 'Get help with my finances';
        const buttonLabelMap = {
            mortgage: 'Get help with my mortgage',
            'pension-options': 'Get help with my pensions',
            'finances-review': 'Get help with my finances',
            'pension-transfer': 'Get help with my pensions',
            'inheritance-investment': 'Get help with my investments',
            'investment-and-pension': 'Get help with my investments',
        };

        if (state && state.key) {
            const needKey = state.key;

            if (buttonLabelMap[needKey]) {
                label = buttonLabelMap[needKey];
            }
        }

        return label;
    };

    const renderMortgageQuestions = () => {
        if (state.adviceArea === 392) {
            const maxWidthInputs = '280px';

            return (
                <div>
                    <Input
                        name="mortgageValue"
                        label="What is the value of the property you want to purchase or remortgage?"
                        placeholder="£50,000"
                        widthProportion="fixed"
                        fixedWidth={maxWidthInputs}
                        onClick={handleClick}
                        required
                        isCurrency={true}
                        control={{ ...control }}
                        onBlur={handleBlur}
                        register={{
                            ...register('mortgageValue', {
                                required:
                                    'Please enter the value of the property you want to purchase or remortgage.',
                            }),
                        }}
                    />

                    <Input
                        name="deposit"
                        label="What is your potential deposit (or remortgage amount)?"
                        placeholder="£10,000"
                        widthProportion="fixed"
                        fixedWidth={maxWidthInputs}
                        onClick={handleClick}
                        required
                        isCurrency={true}
                        control={{ ...control }}
                        register={{
                            ...register('deposit', {
                                required:
                                    'Please enter your potential deposit (or remortgage amount).',
                            }),
                        }}
                    />

                    <Input
                        name="annualIncome"
                        label="What is your annual income? (If it's a joint mortgage,
                            enter your combined income)"
                        placeholder="£35,000"
                        widthProportion="fixed"
                        fixedWidth={maxWidthInputs}
                        onClick={handleClick}
                        required
                        isCurrency={true}
                        control={{ ...control }}
                        register={{
                            ...register('annualIncome', {
                                required: 'Please enter your your annual income.',
                            }),
                        }}
                    />

                    <label className="semi-bold inline-block push-down-10">
                        When are you looking to purchase the property or remortgage?
                    </label>

                    <Dropdown
                        name="adviceTime"
                        optionsType="adviceTime"
                        widthProportion="fixed"
                        fixedWidth={maxWidthInputs}
                        required
                        register={{
                            ...register('adviceTime', {
                                required:
                                    'Please enter when are you looking to purchase the property or remortgage.',
                            }),
                        }}
                    />
                </div>
            );
        }
        return <div></div>;
    };

    useEffect(() => {
        if (state.formData) {
            setValue('postcode', state.formData.postcode);
            if (state.adviceArea !== 392) {
                setValue('wealthLevel', state.formData.wealthLevel);
            }
            if (state.adviceArea === 392) {
                setValue('mortgageValue', state.formData.mortgageValue);
                setValue('deposit', state.formData.deposit);
                setValue('annualIncome', state.formData.annualIncome);
                setValue('adviceTime', state.formData.adviceTime);
            }
            setValue('fullName', state.formData.fullName);
            setValue('email', state.formData.email);
            setValue('phone', state.formData.phone);
            if (state.adviceArea === 393 || state.adviceArea === 635) {
                setValue('dbPension', state.formData.dbPension);
            }
            setValue('isLocationImportant', state.formData.isLocationImportant);
        }
    }, []);

    useEffect(() => {
        if (state.postcode) {
            setValue('postcode', state.postcode);
        }
    }, [state.postcode]);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div>
                <Input
                    name="postcode"
                    label="What is your postcode?"
                    placeholder="SW1P 3JX"
                    defaultValue="SW1P 3JX"
                    widthProportion="fixed"
                    fixedWidth={maxWidthInputs}
                    onClick={handleClick}
                    onBlur={handleBlur}
                    required
                    register={{
                        ...register('postcode', {
                            required: 'Please enter your post code.',
                            maxLength: 8,
                        }),
                    }}
                />

                {state.adviceArea !== 392 && (
                    <Input
                        name="wealthLevel"
                        label="What is the total value of your savings? (excluding property)"
                        placeholder="£50,000"
                        widthProportion="fixed"
                        fixedWidth={maxWidthInputs}
                        onClick={handleClick}
                        required
                        isCurrency={true}
                        onBlur={handleBlur}
                        control={{ ...control }}
                        register={{
                            ...register('wealthLevel', {
                                required: 'Please enter total value of your savings.',
                            }),
                        }}
                    />
                )}

                {state.adviceArea === 392 && renderMortgageQuestions()}

                <Input
                    name="fullName"
                    label="Your full name"
                    placeholder="Fred Smith"
                    widthProportion="fixed"
                    onClick={handleClick}
                    fixedWidth={maxWidthInputs}
                    required
                    register={{
                        ...register('fullName', { required: 'Please enter your full name.' }),
                    }}
                />

                <Input
                    name="email"
                    label="Your email"
                    placeholder="fred@fs.com"
                    widthProportion="fixed"
                    fixedWidth={maxWidthInputs}
                    onClick={handleClick}
                    hintText="This is where we will send your confirmation email"
                    required
                    register={{
                        ...register('email', {
                            required: 'Please enter your e-mail.',
                            pattern: {
                                value: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g,
                                message: 'This is not a valid email',
                            },
                        }),
                    }}
                />

                <Input
                    name="phone"
                    label="Your phone number"
                    placeholder="01234 567 890"
                    widthProportion="fixed"
                    isPhone={true}
                    fixedWidth={maxWidthInputs}
                    onClick={handleClick}
                    hintText="Your chosen adviser will give you a quick call to offer you ideas.
                                    Please enter a valid UK telephone number, e.g. 01234 567 890"
                    required
                    control={{ ...control }}
                    register={{
                        ...register('phone', {
                            required: 'Please enter your phone number.',
                            maxLength: 13,
                        }),
                    }}
                />

                {(state.adviceArea === 393 || state.adviceArea === 635) && (
                    <Checkbox
                        name="dbPension"
                        label="I have a final salary / defined benefit pension"
                        onClick={handleCheckboxClick}
                        register={{ ...register('dbPension') }}
                    />
                )}

                <RadioGroup
                    name="isLocationImportant"
                    label="Do you mind where your adviser is based?"
                    options={[{value: "Yes", label: "Yes"}, {value: "No", label: "No"}]}
                    required
                    register={{
                        ...register('isLocationImportant', {
                            required:
                                'Please check an option.',
                        }),
                    }}
                />

                <div className="push-up-20">
                    <button type="submit" className="bigger-button vouchedfor-brand" name="next">
                        {getButtonLabel()}
                    </button>
                </div>

                <div className="inline-block text-align-center push-up-20">
                    <div className="app__form-page__security-message">
                        <div className="app__form-page__security-message__icon">
                            <Icon icon="lock" size="22px" />
                        </div>
                        <div>
                            You are protected by SSL security. We go above and beyond industry
                            standards to ensure your data is safe
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default MatchForm;
